type BenefitItem = {
  bold: string;
  text?: string;
};

type Props = {
  heading?: string;
  items: BenefitItem[];
};

function CheckCircle() {
  return (
    <svg
      class="benefits-list__icon"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="11" fill="currentColor" style="color: var(--m-green)" />
      <path
        d="M7.5 12.5l3 3 6-6"
        stroke="#fff"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function BenefitsList({ heading, items }: Props) {
  return (
    <div class="benefits-list">
      {heading && <h2 class="benefits-list__heading">{heading}</h2>}
      <div class="benefits-list__items">
        {items.map((item, i) => (
          <div key={i} class="benefits-list__item">
            <CheckCircle />
            <span class="benefits-list__text">
              <strong>{item.bold}</strong>
              {item.text && ` ${item.text}`}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
